<template>
    <div class="layout d-flex flex-column">
        <div class="layout__header">
            <main-menu />
        </div>
        <app-secondary-menu />
        <div class="layout__panels d-flex flex-column flex-md-row">
            <div class="panels__panel-left d-none d-lg-flex flex-column justify-content-between d-print-none">
                <div v-if="showMenu">
                    <router-view v-if="isAccountSection" name="sidebar"></router-view>
                    <page-options-list v-else :options="options" />
                </div>
                <div class="legal d-none d-sm-block">
                    &copy; Shatter Seguridad 2018. Todos los derechos reservados.
                </div>
            </div>
            <div class="panels__panel-right">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
    import MainMenu from '../Header/MainMenu/MainMenu.vue';
    import PageOptionsList from '../Controls/PageOptions/PageOptionsList.vue';
    import { mapGetters } from 'vuex';
    import SecondaryMenu from '../Header/SecondaryMenu/SecondaryMenu';

    export default {
        name: 'layout',
        components: {
            MainMenu,
            PageOptionsList,
            appSecondaryMenu: SecondaryMenu
        },
        computed: {
            ...mapGetters({
                options: 'menuOptions',
                shift: 'shift'
            }),
            showMenu() {
                if (this.user.profile.slug !== 'vigilante') return true;

                return !!this.shift;
            },
            isAccountSection() {
                return this.$route.matched.some(
                    record => record.path && record.path.includes('account')
                );
            }
        }
    }
</script>